export const RQ_GET_CATEGORY_API = {
  url: 'api/Category/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_CATEGORY_REGISTER = {
  url: 'api/register/category',
  method: 'POST',
  auth: true,
};

export const RQ_UPDATE_CATEGORY = {
  url: 'api/update/Category/<%= id %>',
  method: 'PUT',
  auth: true,
};

export const RQ_DELETE_CATEGORY = {
  url: 'api/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
